import React, { CSSProperties } from 'react';
import { color, size, weight } from 'designs';

type TextElement = 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3';

type TextProps = {
  children: React.ReactNode;
  /**
   * The element to render. Kept separate from the visual treatment so heading
   * level can follow the document outline rather than the type size.
   */
  as?: TextElement;
  color?: string;
  size?: string;
  weight?: string;
  tracking?: string;
  align?: CSSProperties['textAlign'];
  transform?: CSSProperties['textTransform'];
  /** For layout only — margins, widths. Typography belongs in the props. */
  className?: string;
};

/**
 * The site's text primitive. Every value defaults to a design token, and the
 * atom knows nothing about the pages it appears on.
 */
const Text: React.FC<TextProps> = ({
  children,
  as: Element = 'span',
  color: textColor = color.brandInk,
  size: fontSize = size.medium,
  weight: fontWeight = weight.regular,
  tracking: letterSpacing,
  align: textAlign,
  transform: textTransform,
  className,
}) => {
  return (
    <Element
      className={className}
      style={{
        color: textColor,
        fontSize,
        fontWeight,
        letterSpacing,
        textAlign,
        textTransform,
      }}
    >
      {children}
    </Element>
  );
};

export default Text;
